import { FeathersModel } from './feathersModel'

export class ContinuingEducationCourse extends FeathersModel {
  static serviceName = 'continuing-education-courses'

  workerId: number
  name: string
  durationMinutes: number
  realizator: string
  realizationYear: number | null
}
